import '../../components/Avatar.js';
import '../../components/CollapsibleSection.js';
import '../../components/DefaultLoadingComponent.js';
import '../../components/GooglePlaceAddress.js';
import React__default, { useState, useEffect } from 'react';
import '../../components/Image.js';
import '../../components/PromotionAlert.js';
import '../../components/StandardHeader.js';
import '../../components/Chat.js';
import '../../components/CreditApp.js';
import '../../components/EkhoDealerFooter.js';
import '../../components/FinancingModal.js';
import '../../components/FinancingMonthlyEstimateModal.js';
import '../../components/Logo.js';
import '../../components/OrLineDivider.js';
import '../../components/PreviewUpload.js';
import '../../components/PriceSuffix.js';
import 'formik';
import 'libphonenumber-js';
import 'yup';
import '../../constants.js';
import '../../server/serverCalls.js';
import '../../types/CustomerIO.js';
import '../../utils/createLog.js';
import '../../types/SupportHours.js';
import 'bad-words';
import 'moment';
import 'ua-parser-js';
import '../../types/ActionItem.js';
import '../../types/Address.js';
import '../../types/admin_portal/conversations/api/ConversationStatsResponse.js';
import '../../types/admin_portal/conversations/api/GetConversationMessagesResponse.js';
import '../../types/admin_portal/discounts/DiscountCombination.js';
import '../../types/admin_portal/discounts/DiscountMethod.js';
import '../../types/admin_portal/discounts/DiscountStatus.js';
import '../../types/admin_portal/discounts/DiscountType.js';
import '../../types/admin_portal/leads/table/LeadsServiceSort.js';
import '../../types/admin_portal/leads/table/LeadsTableTab.js';
import '../../types/admin_portal/orders/views/OrderDocuments.js';
import '../../types/admin_portal/orders/table/OrderPaymentChoice.js';
import '../../types/admin_portal/orders/table/OrdersServiceSort.js';
import '../../types/admin_portal/orders/table/OrdersTableTab.js';
import '../../types/admin_portal/orders/validation/vinValidation.js';
import '../../types/admin_portal/orders/validation/odometerValidation.js';
import '../../types/admin_portal/orders/validation/engineNumberValidation.js';
import '../../types/admin_portal/orders/validation/inventoryValidation.js';
import '../../types/admin_portal/orders/validation/tempTagValidation.js';
import '../../types/admin_portal/orders/validation/assemblyValidation.js';
import '../../types/admin_portal/orders/validation/inspectionValidation.js';
import '../../types/admin_portal/orders/validation/transitValidation.js';
import '../../types/admin_portal/orders/validation/fileUploadValidation.js';
import '../../types/admin_portal/orders/validation/noteValidation.js';
import '../../types/admin_portal/orders/validation/warrantyValidation.js';
import '../../types/admin_portal/orders/validation/fulfillmentValidation.js';
import '../../types/admin_portal/orders/validation/accessoriesValidation.js';
import '../../types/admin_portal/orders/validation/productionValidation.js';
import '../../types/admin_portal/team/validation/teamSearchDto.js';
import '../../types/admin_portal/team/validation/teamCreateMembersDto.js';
import '../../types/AlgoliaSearchRecord.js';
import '../../types/Auth.js';
import '../../types/auto_debit/Charge.js';
import '../../types/notifications/NotificationEvent.js';
import '../../types/notifications/NotificationSubscription.js';
import '../../types/notifications/NotificationTemplate.js';
import '../../types/BrexTransfer.js';
import '../../types/Buyer.js';
import '../../types/CheckoutCart.js';
import '../../types/CheckoutDisclosures.js';
import '../../types/conversations/Conversation.js';
import '../../types/conversations/ConversationStats.js';
import '../../types/coverage/CoverageBundle.js';
import '../../types/coverage/CoverageProduct.js';
import '../../types/Credits.js';
import '../../types/CtaConfig.js';
import '../../types/dashboards/AdminPortalOrdersDashboard.js';
import '../../types/dashboards/RetailerPortalOrdersDashboard.js';
import '../../types/DiscountCampaign.js';
import '../../types/DiscountTypes.js';
import '../../types/imports/ImportJob.js';
import '../../types/leads/Lead.js';
import '../../types/IncomingCheckoutCart.js';
import '../../types/inventory/Assignment.js';
import '../../types/inventory/CosmeticReport.js';
import '../../types/inventory/InventoryItem.js';
import '../../types/inventory/LockRequest.js';
import '../../types/inventory/MechanicalReport.js';
import '../../types/invitations/Invitation.js';
import '../../types/LegacyIncomingCheckoutCart.js';
import '../../types/lender/events.js';
import '../../types/lender/general.js';
import '../../types/lender/generic.js';
import '../../types/lender/Lender.js';
import '../../types/Listing.js';
import '../../types/Logos.js';
import '../../types/Membership.js';
import '../../types/Oem.js';
import '../../types/OrderExternalStatus.js';
import '../../types/OverflowFees.js';
import '../../types/Payable.js';
import '../../types/PaymentConfig.js';
import '../../types/Payout.js';
import '../../types/PdfFieldTag.js';
import '../../types/PlacedOrder.js';
import '../../types/preorders/Preorder.js';
import '../../types/preorders/PreorderPaymentConfig.js';
import '../../types/PricingModelDetails.js';
import '../../types/PropertyAggregation.js';
import '../../types/pubsub/EventCodes.js';
import '../../types/pubsub/Topics.js';
import '../../types/servicesProviders/services/Services.js';
import '../../types/servicesProviders/services/ServicesProviderAssemblyData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillmentData.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendorData.js';
import '../../types/servicesProviders/services/ServicesProviderDeliveryData.js';
import '../../types/servicesProviders/services/ServicesProviderDomainsData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingData.js';
import '../../types/servicesProviders/services/ServicesProviderFreightData.js';
import '../../types/servicesProviders/services/ServicesProviderInspectionData.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderInventoryData.js';
import '../../types/servicesProviders/services/ServicesProviderLicensureData.js';
import '../../types/servicesProviders/services/ServicesProviderOriginatorData.js';
import '../../types/servicesProviders/services/ServicesProviderPayableData.js';
import '../../types/servicesProviders/services/ServicesProviderPickupData.js';
import '../../types/servicesProviders/services/ServicesProviderPlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwnerData.js';
import '../../types/servicesProviders/services/ServicesProviderRegistrationData.js';
import '../../types/servicesProviders/services/ServicesProviderSaleData.js';
import '../../types/servicesProviders/services/ServicesProviderTariffData.js';
import '../../types/servicesProviders/services/ServicesProviderTempTagData.js';
import '../../types/servicesProviders/services/ServicesProviderTitlingData.js';
import '../../types/servicesProviders/services/ServicesProviderAssembly.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillment.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTax.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendor.js';
import '../../types/servicesProviders/services/ServicesProviderDelivery.js';
import '../../types/servicesProviders/services/ServicesProviderDomains.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTax.js';
import '../../types/servicesProviders/services/ServicesProviderFinancing.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerage.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageSubvention.js';
import '../../types/servicesProviders/services/ServicesProviderFreight.js';
import '../../types/servicesProviders/services/ServicesProviderInspection.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderInventory.js';
import '../../types/servicesProviders/services/ServicesProviderLicensure.js';
import '../../types/servicesProviders/services/ServicesProviderOriginator.js';
import '../../types/servicesProviders/services/ServicesProviderPayable.js';
import '../../types/servicesProviders/services/ServicesProviderPickup.js';
import '../../types/servicesProviders/services/ServicesProviderPlatform.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFees.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwner.js';
import '../../types/servicesProviders/services/ServicesProviderRegistration.js';
import '../../types/servicesProviders/services/ServicesProviderSale.js';
import '../../types/servicesProviders/services/ServicesProviderTariff.js';
import '../../types/servicesProviders/services/ServicesProviderTempTag.js';
import '../../types/servicesProviders/services/ServicesProviderTitling.js';
import '../../types/ReEngagementConfig.js';
import '../../types/Repository.js';
import '../../types/Sardine.js';
import '../../types/Scraping.js';
import '../../types/servicesProviders/configurations/AiBdcSettings.js';
import '../../types/servicesProviders/configurations/AssemblyServiceConfig.js';
import '../../types/servicesProviders/configurations/BdcServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageFulfillmentServiceConfig.js';
import '../../types/servicesProviders/configurations/CoveragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageTaxServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageVendorServiceConfig.js';
import '../../types/servicesProviders/configurations/DeliveryServiceConfig.js';
import '../../types/servicesProviders/configurations/DomainsServiceConfig.js';
import '../../types/servicesProviders/configurations/SharedServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokeragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokerageServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingServiceConfig.js';
import '../../types/servicesProviders/configurations/FreightServiceConfig.js';
import '../../types/servicesProviders/configurations/InspectionServiceConfig.js';
import '../../types/servicesProviders/configurations/InventoryServiceConfig.js';
import '../../types/servicesProviders/configurations/LicensureServiceConfig.js';
import '../../types/servicesProviders/configurations/PickupServiceConfig.js';
import '../../types/servicesProviders/configurations/PlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/ProgramOwnerServiceConfig.js';
import '../../types/servicesProviders/configurations/SaleServiceConfig.js';
import '../../types/servicesProviders/configurations/TempTagServiceConfig.js';
import '../../types/servicesProviders/constants/OnboardingCode.js';
import '../../types/servicesProviders/constants/ProductConfigurationOptions.js';
import '../../types/servicesProviders/serviceAccess/OnboardingCodeToServiceAccess.js';
import '../../types/servicesProviders/serviceAccess/serviceAccess.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessServicesTemplates.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessTemplateCode.js';
import '../../types/servicesProviders/serviceAccess/ServiceSections.js';
import '../../types/servicesProviders/ServicesProvider.js';
import '../../types/servicesProviders/ServicesProviderConfig.js';
import '../../types/servicesProviders/ServicesProviderData.js';
import '../../types/servicesProviders/ServicesProviderPricing.js';
import '../../types/SpecEnrichment.js';
import '../../types/StateAbbreviation.js';
import '../../types/systems/ClientConfig.js';
import '../../types/systems/pcrs/Pcrs.js';
import '../../types/systems/SystemType.js';
import '../../types/UnitedPostalService.js';
import '../../types/Units.js';
import '../../types/User.js';
import '../../types/validation/Validation.js';
import '../../types/Validator.js';
import '../../types/VehicleSpecMetadata.js';
import '../../types/VehicleTypes.js';
import '../../components/bootstrap/Button.js';
import '../../components/bootstrap/forms/FormGroup.js';
import '../../components/bootstrap/forms/Input.js';
import '../../components/bootstrap/forms/Select.js';
import '../../components/bootstrap/forms/Textarea.js';
import '../../components/bootstrap/Modal.js';
import '../../components/bootstrap/Spinner.js';
import '../../components/icon/Icon.js';
import '../../components/TagWrapper.js';
import '../../components/TransferAction.js';
import '../../components/UserContact.js';
import '../../components/VerticalStepper.js';
import '../../components/Wizard.js';
import '../../components/PreQualFailureModal.js';
import '../../components/PreQualInfoCollectModal.js';
import '../../components/PreQualModal.js';
import '../../components/PreQualSuccessModal.js';
import '../../components/bootstrap/Accordion.js';
import '../../components/bootstrap/Alert.js';
import '../../components/bootstrap/Badge.js';
import '../../components/bootstrap/Breadcrumb.js';
import '../../components/bootstrap/Card.js';
import '../../components/bootstrap/Carousel.js';
import '../../components/bootstrap/CarouselCaption.js';
import '../../components/bootstrap/CarouselContainer.js';
import '../../components/bootstrap/CarouselControl.js';
import '../../components/bootstrap/CarouselIndicators.js';
import '../../components/bootstrap/CarouselItem.js';
import '../../components/bootstrap/CarouselSlide.js';
import '../../components/bootstrap/Collapse.js';
import '../../components/bootstrap/Dropdown.js';
import '../../components/bootstrap/forms/Checks.js';
import '../../components/bootstrap/forms/FormText.js';
import '../../components/bootstrap/forms/InputGroup.js';
import '../../components/bootstrap/forms/Label.js';
import '../../components/bootstrap/forms/Validation.js';
import '../../components/bootstrap/ListGroup.js';
import '../../components/bootstrap/Nav.js';
import '../../components/bootstrap/OffCanvas.js';
import '../../components/bootstrap/Option.js';
import '../../components/bootstrap/Pagination.js';
import '../../components/bootstrap/Popovers.js';
import '../../components/bootstrap/Progress.js';
import '../../components/bootstrap/RadioAccordion.js';
import '../../components/bootstrap/ScrollspyNav.js';
import '../../components/bootstrap/SectionAccordion.js';
import '../../components/bootstrap/Toasts.js';
import '../../components/bootstrap/Tooltips.js';
import '../../components/bootstrap/utils.js';
import '../../components/extras/calendarHelper.js';
import '../../components/extras/Chart.js';
import '../../components/extras/PlaceholderImage.js';
import '../../components/footers/InfoCollectFooter.js';
import '../../components/footers/StandardFooter.js';
import '../../components/headers/StandardPageHeader.js';
import '../../components/headers/StandardPageSubHeader.js';
import '../../components/extras/PercentComparison.js';
import '../../components/extras/ReactCreditCardsContainer.js';
import '@babel/runtime/helpers/defineProperty';
import 'react-notifications-component';
import '../../components/extras/Timeline.js';
import '../../components/extras/Todo.js';
import '../../layout/Navigation/Navigation.js';
import '../../layout/Page/Page.js';
import '../../layout/PageWrapper/PageWrapper.js';
import '../../layout/Portal/Portal.js';
import '../../layout/SubHeader/SubHeader.js';
import '../../contexts/themeContext.js';
import 'framer-motion';
import 'react-use';
import '@reactour/tour';
import '../atoms/authAtoms.js';
import '../atoms/mfaChallengeAtoms.js';
import '../atoms/mfaSmsAtoms.js';
import 'firebase/auth';
import 'jotai';
import { useAuthContext } from '../providers/AuthContext.js';
import '@tanstack/react-query';
import { getPasswordChecks, isPasswordValid } from '../utils/passwordValidation.js';
import 'react-router-dom';
import '../../rev/layouts/Alignment/alignment.scss';
import '../../rev/layouts/Box.js';
import '../../rev/layouts/Group.js';
import '../../rev/layouts/Section.js';
import '../../rev/layouts/Spacing/spacing.scss';
import '../../rev/layouts/Stack.js';
import '../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../rev/atoms/Button.js';
import { Callout } from '../../rev/atoms/Callout.js';
import '../../rev/atoms/Card.scss';
import '../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../rev/atoms/CheckboxGroup.scss';
import '../../rev/atoms/Tag.scss';
import '../../rev/atoms/Chip.scss';
import '../../rev/atoms/DateInput.js';
import '../../rev/atoms/Text.js';
import '../../rev/atoms/Divider.scss';
import '../../rev/atoms/Spinner.scss';
import '../../rev/atoms/Dropzone.scss';
import '../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../rev/molecules/RichDescription.js';
import '../../rev/molecules/TitleGroup.scss';
import '../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../rev/atoms/LabelledList.scss';
import '../../rev/atoms/LabelPrice.scss';
import '../../rev/atoms/Link.scss';
import '../../rev/atoms/ListViewGroup.scss';
import '../../rev/atoms/ListViewRow.scss';
import '../../rev/atoms/Note.scss';
import '../../rev/atoms/OldTextInput.js';
import '../../rev/atoms/RadioGroup.scss';
import '../../rev/atoms/SegmentedControl.scss';
import '../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../rev/molecules/Tooltip/Tooltip.js';
import '../../rev/atoms/Slider.scss';
import '../../rev/atoms/SteppedProgressBar.scss';
import '../../rev/atoms/Switch.js';
import '../../rev/atoms/Tabs.scss';
import '../../rev/atoms/TextArea.js';
import { TextInput } from '../../rev/atoms/TextInput.js';
import '../../rev/atoms/TimeInput.js';
import '../../rev/atoms/ToggleButton.js';
import '../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../rev/molecules/Accordion.scss';
import '../../rev/molecules/ActionMenu.scss';
import '../../rev/molecules/BankInfo/BankInfo.scss';
import '../../rev/molecules/Carousel.scss';
import '../../rev/molecules/ContentSlider.js';
import '../../rev/molecules/Drawer.js';
import '../../rev/molecules/Dropdown.scss';
import '../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../rev/molecules/Lightbox.scss';
import { GuardId } from '../../components/loadingAtoms.js';
import '../../rev/molecules/LoadingPage.scss';
import '../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../utils/addressCache.js';
import '../../rev/molecules/OldAddressInput.scss';
import '../../rev/atoms/Button.scss';
import '../../rev/molecules/OrderFooter.scss';
import '../../rev/molecules/Pagination.scss';
import '../../rev/molecules/Popover.js';
import '../../rev/molecules/Popup.scss';
import '../../rev/molecules/SearchInput.scss';
import '../../rev/molecules/Sheet.js';
import '../../rev/molecules/Table/Table.scss';
import '../../rev/molecules/Toast.js';
import '../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../rev/organisms/AddressInput.js';
import '../../rev/sections/CalculatePaymentModal.scss';
import '../../rev/sections/ConfirmAddressModal.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import 'react-hook-form';
import '../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../rev/sections/FormModal/FormModal.scss';
import '../../rev/sections/FormModal/types.js';
import '../../rev/sections/LeadsSection/LeadCard.scss';
import './AuthPageLayout.scss';
import { AuthErrorState } from './common/AuthErrorState.js';
import { AuthHeader } from './common/AuthHeader.js';
import { CheckIcon, EyeIcon, EyeOffIcon } from './common/AuthIcons.js';
import './common/PinInput.scss';
import './ForgotPasswordForm.scss';
import './MfaChallengeForm.scss';
import 'libphonenumber-js/mobile/examples';
import './ResetPassword.scss';
import { useGuardLoadingState } from '../../hooks/useGuardLoadingState.js';

/**
 * ResetPassword - Form to set a new password using Firebase oobCode
 *
 * States:
 * 1. loading: Verifying the oobCode is valid
 * 2. invalid: oobCode is missing, expired, or already used
 * 3. form: Ready to accept new password
 * 4. success: Password reset complete
 */
const DEFAULT_TITLE = 'Reset password';
const DEFAULT_SUBTITLE = 'Choose a new password for your account.';
const DEFAULT_SUBMIT_BUTTON_TEXT = 'Reset password';
const DEFAULT_SUCCESS_TITLE = 'Your password has been updated!';
const DEFAULT_SUCCESS_SUBTITLE = 'You can now sign in with your new password.';
const DEFAULT_SUCCESS_BUTTON_TEXT = 'Continue to log in';
const DEFAULT_INVALID_REASON_TITLE = 'Expired link';
const DEFAULT_REQUEST_NEW_LINK_BUTTON_TEXT = 'Request new link';
function ResetPasswordForm({ oobCode, onSuccess, onBackToLogin, onRequestNewLink, title = DEFAULT_TITLE, subtitle = DEFAULT_SUBTITLE, submitButtonText = DEFAULT_SUBMIT_BUTTON_TEXT, successTitle = DEFAULT_SUCCESS_TITLE, successSubtitle = DEFAULT_SUCCESS_SUBTITLE, successButtonText = DEFAULT_SUCCESS_BUTTON_TEXT, invalidReasonTitle = DEFAULT_INVALID_REASON_TITLE, requestNewLinkButtonText = DEFAULT_REQUEST_NEW_LINK_BUTTON_TEXT, skipSuccessScreen = false, }) {
    const { authService } = useAuthContext();
    // Page state
    const [resetState, setResetState] = useState('loading');
    const [invalidReason, setInvalidReason] = useState('');
    const [resetCodeEmail, setResetCodeEmail] = useState(null);
    const [successPassword, setSuccessPassword] = useState(null);
    // Form state
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    // Submission state
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    useGuardLoadingState(GuardId.AUTH, resetState === 'loading');
    // Verify oobCode on mount
    useEffect(() => {
        const verifyCode = async () => {
            if (!oobCode) {
                setResetState('invalid');
                setInvalidReason('No reset code found. Please request a new password reset link.');
                return;
            }
            try {
                const email = await authService.verifyPasswordResetCode(oobCode);
                setResetCodeEmail(email);
                setResetState('form');
            }
            catch (err) {
                const authError = err;
                setResetState('invalid');
                setInvalidReason(authError.message);
            }
        };
        verifyCode();
    }, [oobCode, authService]);
    // Password validation
    const passwordChecks = getPasswordChecks(newPassword);
    const passwordIsValid = isPasswordValid(newPassword);
    const passwordsMatch = newPassword === confirmPassword && confirmPassword.length > 0;
    const handleSubmit = async () => {
        setError(null);
        // Validate
        if (!passwordIsValid) {
            setError('Please ensure your password meets all requirements.');
            return;
        }
        if (!passwordsMatch) {
            setError('Passwords do not match.');
            return;
        }
        setIsSubmitting(true);
        try {
            if (!oobCode) {
                setError('Invalid reset link. Please request a new one.');
                return;
            }
            // Both flows use confirmPasswordReset: it sets the password on the account (whether
            // set-password flow from anonymous upgrade or standard reset). User is already signed
            // in via custom token for set flow, so no need for linkWithCredential.
            await authService.confirmPasswordReset(oobCode, newPassword);
            if (skipSuccessScreen) {
                await onSuccess(resetCodeEmail ?? undefined, newPassword);
                return;
            }
            setSuccessPassword(newPassword);
            setResetState('success');
        }
        catch (err) {
            const authError = err;
            setError(authError.message);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    // Loading state
    if (resetState === 'loading') {
        return (React__default.createElement("div", { className: 'reset-password-content' },
            React__default.createElement("div", { className: 'auth-page-header' },
                React__default.createElement("h1", { className: 'auth-page-title' }, "Verifying link..."),
                React__default.createElement("p", { className: 'auth-page-subtitle' }, "Please wait while we verify your password reset link."))));
    }
    // Invalid code state
    if (resetState === 'invalid') {
        return (React__default.createElement(AuthErrorState, { title: invalidReasonTitle, message: invalidReason, primaryButtonText: requestNewLinkButtonText, onPrimaryAction: onRequestNewLink, onBackToLogin: onBackToLogin }));
    }
    // Success state (reset flow only; set flow navigates from parent after onSuccess)
    if (resetState === 'success') {
        return (React__default.createElement("div", { className: 'reset-password-content' },
            React__default.createElement("div", { className: 'auth-page-header center-text' },
                React__default.createElement("div", { className: 'reset-password-icon' },
                    React__default.createElement(CheckIcon, null)),
                React__default.createElement("h1", { className: 'auth-page-title' }, successTitle),
                React__default.createElement("p", { className: 'auth-page-subtitle' }, successSubtitle)),
            React__default.createElement("div", { className: 'auth-actions' },
                React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', onPress: () => onSuccess(resetCodeEmail ?? undefined, successPassword ?? undefined) }, successButtonText))));
    }
    // Form state - main reset password form
    return (React__default.createElement("div", null,
        React__default.createElement(AuthHeader, { title: title, details: [subtitle] }),
        React__default.createElement("div", { className: 'auth-form-fields' },
            React__default.createElement("div", { className: 'reset-password-field' },
                React__default.createElement(TextInput, { label: 'New password', type: showNewPassword ? 'text' : 'password', value: newPassword, onChange: setNewPassword, placeholder: '', name: 'newPassword', ariaLabel: 'New password', "aria-describedby": 'password-requirements', rightContent: React__default.createElement("button", { type: 'button', className: 'auth-password-toggle', onClick: () => setShowNewPassword(!showNewPassword), "aria-label": showNewPassword ? 'Hide password' : 'Show password' }, showNewPassword ? React__default.createElement(EyeIcon, null) : React__default.createElement(EyeOffIcon, null)) }),
                React__default.createElement("ul", { id: 'password-requirements', className: 'reset-password-requirements', "aria-label": 'Password requirements' },
                    React__default.createElement("li", { className: `reset-password-requirement ${passwordChecks.minLength ? 'valid' : ''}`, "aria-label": `8 or more characters: ${passwordChecks.minLength ? 'met' : 'not met'}` }, "8 or more characters"),
                    React__default.createElement("li", { className: `reset-password-requirement ${passwordChecks.hasUppercase && passwordChecks.hasLowercase
                            ? 'valid'
                            : ''}`, "aria-label": `Uppercase and lowercase letters: ${passwordChecks.hasUppercase && passwordChecks.hasLowercase
                            ? 'met'
                            : 'not met'}` }, "Uppercase and lowercase letters"),
                    React__default.createElement("li", { className: `reset-password-requirement ${passwordChecks.hasNumber ? 'valid' : ''}`, "aria-label": `At least one number: ${passwordChecks.hasNumber ? 'met' : 'not met'}` }, "At least one number"),
                    React__default.createElement("li", { className: `reset-password-requirement ${passwordChecks.hasSpecialChar ? 'valid' : ''}`, "aria-label": `At least one special character: ${passwordChecks.hasSpecialChar ? 'met' : 'not met'}` }, "At least one special character (e.g., ! @ # $ %)"))),
            React__default.createElement(TextInput, { label: 'Confirm password', type: showConfirmPassword ? 'text' : 'password', value: confirmPassword, onChange: setConfirmPassword, placeholder: '', name: 'confirmPassword', ariaLabel: 'Confirm password', hasError: confirmPassword.length > 0 && !passwordsMatch
                    ? 'Passwords do not match'
                    : false, rightContent: React__default.createElement("button", { type: 'button', className: 'auth-password-toggle', onClick: () => setShowConfirmPassword(!showConfirmPassword), "aria-label": showConfirmPassword ? 'Hide password' : 'Show password' }, showConfirmPassword ? React__default.createElement(EyeIcon, null) : React__default.createElement(EyeOffIcon, null)) })),
        error && React__default.createElement(Callout, { variant: 'error', message: error }),
        React__default.createElement("div", { className: 'auth-actions' },
            React__default.createElement(Button, { size: 'large', variant: 'filled', className: 'auth-primary-button', onPress: handleSubmit, isDisabled: isSubmitting || !passwordIsValid || !passwordsMatch, isLoading: isSubmitting }, submitButtonText),
            React__default.createElement("button", { type: 'button', className: 'reset-password-back-link', onClick: onBackToLogin }, "Back to log in"))));
}

export { ResetPasswordForm };
//# sourceMappingURL=ResetPasswordForm.js.map
